import apiDynamicList from '@/api/apiDynamicList'
import apiVideo from '@/api/apiVideo'

const state = {
  visitedViews: [],
  cachedViews: [],

  //是否更新过报警提醒
  changeAlarmReminder: false,

  // 报警处理条数微章显示
  alarmNum: 0,
  // 报警处理最近1分钟条数微章显示
  alarmRecent1Number: 0,
  // 报警处理最近5分钟条数微章显示
  alarmRecent5Number: 0,
  // 报警处理AI预警条数微章显示
  AIAlramNumber: 0,
  //报警未处理条数微章显示
  alarmUndisposed: 0,
  //保养条数微章显示
  maintainNumber: 0,
  //过期条数徽章显示
  expireNumber: 0,
  //通知总计
  informTotal: 0,
  //录像正在上传总数
  uploadTotal: 0,
  // 报表Tags列表
  reportTags: [],
  // 报表Tags点击快捷按钮
  reportCruTagsSelectd: {},
  // 报表Tags当前要删除快捷按钮
  reportCruTagsDeleteItem: {},
  // 报警 弹窗显示
  alarmViewDialogOpen: false,
  // 自定报表先加载
  customReportsLoadedFirst: false,
  // 菜单快捷键按钮列表
  menuTagList: [
    {
      title: '智慧大屏',
      icon: 'mdi-monitor-dashboard',
      id: 'bigtest',
      name: 'title.bigtest',
      selected: true,
      isShow: true,
      access_code: 1000902,
    },
    {
      title: 'Dashboard',
      id: 'dashboard',
      name: 'title.dashboard',
      isShow: true,
      icon: 'mdi-view-dashboard',
      access_code: 1000003,
      selected: true,
    },
    {
      title: '实时监控',
      id: 'realTimeMonitor',
      name: 'home.realTimeMonitor',
      isShow: true,
      icon: 'mdi-map-marker-radius',
      access_code: 1000004,
      selected: false,
    },
    {
      title: '实时视频',
      id: 'videoMonitor',
      name: 'title.videoMonitor',
      isShow: true,
      icon: 'mdi-google-lens',
      access_code: 1000013,
      selected: false,
      svg: 'videomonitor',
      isSvg: true,
    },
    {
      title: '轨迹回放',
      id: 'trackPlayback',
      name: 'home.trackPlayback',
      isShow: true,
      icon: 'mdi-map-marker-path',
      access_code: 1000005,
      selected: false,
      svg: 'trackplayback',
      isSvg: true,
    },
    {
      title: '录像回放',
      id: 'videoPlayback',
      name: 'title.videoPlayback',
      isShow: true,
      icon: 'mdi-movie-play-outline',
      access_code: 1000014,
      selected: false,
      svg: 'videoplayback',
      isSvg: true,
    },
    // {
    //   title: '统计报表',
    //   id: 'statisticalReport',
    //   name: 'home.statisticalReport',
    //   isShow: true,
    //   icon: 'mdi-chart-bar',
    //   access_code: 1000006,
    //   selected: false,
    // },

    // {
    //   title: '电子围栏',
    //   id: 'geoFence',

    //   name: 'title.geoFence',
    //   isShow: true,
    //   icon: 'mdi-fence',
    //   access_code: 1000010,
    //   selected: false,
    // },
    {
      title: '帐号管理',
      id: 'accountManage',
      name: 'title.accountManage',
      isShow: true,
      icon: 'mdi-account',
      access_code: 1000701,
      selected: false,
    },

    {
      title: '车辆管理',
      name: 'title.vehicleSetting',
      id: 'vehicleSetting',
      isShow: true,
      icon: 'mdi-car',
      access_code: 1000703,
      selected: false,
    },
    {
      title: '设备管理',
      id: 'infoManagement',
      name: 'title.infoManagement',
      icon: 'mdi-information',
      isShow: true,
      access_code: 1000702,
      selected: false,
    },
    {
      title: '驾驶员管理',
      name: 'title.driverManagement',
      id: 'driverManagement',
      isShow: true,
      icon: 'mdi-card-account-details',
      access_code: 1000704,
      selected: false,
    },
    {
      title: '规则管理',
      name: 'title.ruleManagement',
      id: 'ruleManagement',
      isShow: true,
      icon: 'mdi-factory',
      access_code: 1000707,
      selected: false,
    },
    {
      title: '保养管理',
      name: 'title.maintenanceManage',
      id: 'maintenanceManage',
      isShow: true,
      icon: 'mdi-car-wrench',
      access_code: 1000901,
      selected: false,
    },
    {
      title: '设备升级',
      name: 'title.otaManage',
      id: 'otaManage',
      isShow: true,
      icon: 'mdi-arrow-up-bold-circle',
      access_code: 1000706,
      selected: true,
    },
  ],
  // 选中的报表类型
  reportTypeSelected: [],
  // 用户菜单偏好（登录清空 menuTagList 前保存，用于 V2 加载后恢复勾选状态）
  savedMenuPreferences: {},
}

const mutations = {
  UPDATE_VISITED_VIEW: (state, view) => {
    for (let v of state.visitedViews) {
      if (v.path === view.path) {
        v = Object.assign(v, view)
        break
      }
    }
  },

  UPDATE_REMINDER: (state, data) => {
    state.changeAlarmReminder = false
    setTimeout(() => {
      state.changeAlarmReminder = data
    }, 1000)
  },

  UPDATE_AIARM_NUM: (state, data) => {
    state.alarmRecent1Number = data.recent1
    state.alarmRecent5Number = data.recent5
    state.AIAlramNumber = data.aiAlram
    state.alarmUndisposed = data.undisposed

    state.alarmNum = data.undisposed
    state.informTotal = state.alarmNum + state.maintainNumber + state.expireNumber
  },
  UPDAT_MAINTAIN_NUM: (state, data) => {
    state.maintainNumber = 0
    if (localStorage.getItem('isSecond') === 'true') {
      state.maintainNumber = data.maintainTotal

      state.informTotal = state.alarmUndisposed + state.maintainNumber + state.expireNumber
    }
  },
  UPDAT_EXPIRE_NUM: (state, data) => {
    state.expireNumber = 0
    if (localStorage.getItem('isSecond') === 'true') {
      state.expireNumber = data.expireTotal
      state.informTotal = state.alarmUndisposed + state.maintainNumber + state.expireNumber
    }
  },
  UPDAT_UPLOAD_NUM: (state, data) => {
    state.uploadTotal = data
  },

  REPORT_TAGS_LIST: (state, data) => {
    // 检查 enableDriverScore 功能开关
    const isDriverScoreEnabled = () => {
      const cm = window.ConfigManager
      const cfg = cm && cm.getConfig ? cm.getConfig() : null
      if (cfg && cfg.features && cfg.features.enableDriverScore === true) {
        return true
      }
      const fs = localStorage.getItem('features')
      if (fs) {
        try {
          const features = JSON.parse(fs)
          if (features.enableDriverScore === true) {
            return true
          }
        } catch (e) {
          console.error('Failed to parse features config:', e)
        }
      }
      return false
    }

    // 如果 enableDriverScore 为 false，过滤掉现有的 report_type=16 报表
    if (!isDriverScoreEnabled()) {
      state.reportTags = state.reportTags.filter((tag) => tag.report_type != 16)
    }

    if (data.length == 0) {
      state.reportTags = []
    } else if (data) {
      let map = new Map()

      // 先将现有的 reportTags 添加到 map 中

      state.reportTags.forEach((ele) => {
        map.set(ele.custom_id, ele)
      })

      // 只在 data 长度为 1 时检查并移除不存在的项
      if (data.length > 1) {
        const newDataId = data[0].custom_id
        // 如果新数据的 ID 不在现有列表中，清空现有列表
        if (!state.reportTags.some((tag) => tag.custom_id === newDataId)) {
          map.clear()
        }
      }

      // 处理新数据
      data.forEach((ele) => {
        // 如果 enableDriverScore 为 false，跳过 report_type=16 的报表
        if (!isDriverScoreEnabled() && ele.report_type == 16) {
          return
        }
        if (!map.has(ele.custom_id)) {
          let isShowLingth =
            state.reportTags.filter((e) => e.isShow).length +
            state.menuTagList.filter((e) => e.isShow).length
          ele.isShow = isShowLingth < 40 ? true : false
          map.set(ele.custom_id, ele)
        } else {
          // 如果存在,就更新图标数据
          var myitem = map.get(ele.custom_id)

          myitem.icon_data = ele.icon_data
          myitem.icon_text = ele.icon_text

          myitem['report_type'] = ele['report_type']
          myitem['name'] = ele['name']
          myitem['time_type'] = ele['time_type']
          myitem['start_time'] = ele['start_time']
          myitem['end_time'] = ele['end_time']
          myitem['front_day'] = ele['front_day']
          myitem['front_time'] = ele['front_time']
          myitem['show_sum'] = ele['show_sum']
          myitem['show_sum_detail'] = ele['show_sum_detail']
          myitem['show_detail_sum'] = ele['show_detail_sum']
          myitem['show_detail'] = ele['show_detail']
          myitem['show_chart'] = ele['show_chart']
          myitem['shortcut'] = ele['shortcut']

          map.set(ele.custom_id, myitem)
        }
      })

      state.reportTags = Array.from(map.values())
    } else {
      state.reportTags = []
    }
  },
  // 点击快捷键
  REPORT_CUR_TAGS_SELECTD: (state, data) => {
    state.reportCruTagsSelectd = [data]
  },
  // 报表快捷键删除
  REPORT_CUR_TAGS_DETELE_ITEM: (state, index) => {
    state.reportTags.splice(index, 1)
    // state.reportCruTagsDeleteItem = data
  },
  // 报表被删除时快捷键也删除
  REPORT_CUR__TO_TAGS_DETELE: (state, id) => {
    let index = state.reportTags.findIndex((e) => e.custom_id == id)
    if (index != -1) {
      state.reportTags.splice(index, 1)
    }
  },
  // 切换快捷键勾选状态
  REPORT_CANCEL_CHECK: (state, item) => {
    let index
    for (let i = 0; i < state.reportTags.length; i++) {
      if (state.reportTags[i].custom_id == item.custom_id) {
        index = i
      }
    }
    state.reportTags[index].isShow = JSON.parse(JSON.stringify(item.isShow))
  },
  // 菜单切换快捷键勾选状态
  MENU_TAG_CANCEL_CHECK: (state, item) => {
    let index
    for (let i = 0; i < state.menuTagList.length; i++) {
      if (state.menuTagList[i].id == item.id) {
        index = i
      }
    }
    state.menuTagList[index].isShow = JSON.parse(JSON.stringify(item.isShow))
  },
  // 自定报表先加载
  CUSTOOM_REPORTS_LOADED_FIRST: (state, flag) => {
    state.customReportsLoadedFirst = flag
  },
  ALARM_VIEW_DIALOG_OPEN: (state, flag) => {
    state.alarmViewDialogOpen = flag
  },
  // 选中的报表类型
  REPORT_TYPE_SELECTED: (state, data) => {
    state.reportTypeSelected = data
  },
  // 快捷菜单快捷键拉拖
  SET_MENU_TAGLIST(state, payload) {
    const oldIndex = payload.oldIndex
    const newIndex = payload.newIndex

    if (
      oldIndex === newIndex ||
      oldIndex < 0 ||
      newIndex < 0 ||
      oldIndex >= state.menuTagList.length ||
      newIndex >= state.menuTagList.length
    ) {
      return
    }

    const movedItem = state.menuTagList.splice(oldIndex, 1)[0]
    state.menuTagList.splice(newIndex, 0, movedItem)
  },

  // 存储menuTagList
  SET_MENU_TAGLIST_ACCESS(state, menuTagList) {
    state.menuTagList = menuTagList
  },

  // 清空 menuTagList（登录时使用，避免显示旧的缓存数据）
  // 清空前先保存用户的勾选偏好，供 V2 加载后恢复
  CLEAR_MENU_TAGLIST(state) {
    const prefs = {}
    state.menuTagList.forEach((item, index) => {
      if (item.access_code) {
        prefs[item.access_code] = {
          isShow: item.isShow,
          selected: item.selected,
          order: index,
        }
      }
    })
    state.savedMenuPreferences = prefs
    state.menuTagList = []
  },

  // 合并默认 menuTagList 与当前缓存，确保新添加的项目不会因缓存而丢失
  MERGE_DEFAULT_MENU_TAGLIST(state, defaultMenuTagList) {
    if (!defaultMenuTagList || !Array.isArray(defaultMenuTagList)) return

    // 创建当前列表的 id 映射
    const currentIds = new Set(state.menuTagList.map(item => item.id))

    // 找出默认列表中有但当前缓存中没有的项目
    const newItems = defaultMenuTagList.filter(item => !currentIds.has(item.id))

    // 将新项目添加到列表末尾
    if (newItems.length > 0) {
      console.log('[tagsView] Adding missing menu items:', newItems.map(i => i.id))
      state.menuTagList = [...state.menuTagList, ...newItems]
    }
  },

  // 从后台 definitions 同步菜单列表
  SYNC_MENU_FROM_DEFINITIONS(state, { menuDefinitions, disabledPermissions }) {
    if (!menuDefinitions || !Array.isArray(menuDefinitions) || menuDefinitions.length === 0) {
      return
    }

    // Keep user preferences from previous menu state.
    const userPreferences = { ...(state.savedMenuPreferences || {}) }
    state.menuTagList.forEach((item, index) => {
      if (item.access_code) {
        userPreferences[item.access_code] = {
          isShow: item.isShow,
          selected: item.selected,
          order: index,
        }
      }
    })

    const disabledSet = new Set(disabledPermissions || [])

    const newMenuTagList = menuDefinitions
      .filter((item) => !disabledSet.has(item.access_code))
      .map((item, definitionIndex) => {
        const pref = userPreferences[item.access_code]
        return {
          access_code: item.access_code,
          id: item.id,
          name: item.name,
          icon: item.icon,
          svg: item.svg,
          isSvg: item.isSvg || false,
          isShow: pref ? pref.isShow : true,
          selected: pref ? pref.selected : false,
          fromDefinitions: true,
          _order: Number.isInteger(pref?.order) ? pref.order : Number.MAX_SAFE_INTEGER,
          _definitionIndex: definitionIndex,
        }
      })
      .sort((a, b) => {
        if (a._order !== b._order) return a._order - b._order
        return a._definitionIndex - b._definitionIndex
      })
      .map(({ _order, _definitionIndex, ...item }) => item)

    if (newMenuTagList.length > 0) {
      console.log('[tagsView] Synced menu from definitions:', newMenuTagList.map(i => i.id))
      state.menuTagList = newMenuTagList
    }
  },

  // 设置报警数量的单独 mutations
  SET_ALARM_RECENT1_NUMBER: (state, data) => {
    state.alarmRecent1Number = data
  },
  SET_ALARM_RECENT5_NUMBER: (state, data) => {
    state.alarmRecent5Number = data
  },
  SET_AI_ALRAM_NUMBER: (state, data) => {
    state.AIAlramNumber = data
  },
  SET_ALARM_UNDISPOSED: (state, data) => {
    state.alarmUndisposed = data
    state.alarmNum = data
    state.informTotal = state.alarmNum + state.maintainNumber + state.expireNumber
  },
}

const actions = {
  updateVisitedView({ commit }, view) {
    commit('UPDATE_VISITED_VIEW', view)
  },

  // 初始化时合并默认 menuTagList
  initializeMenuTagList({ commit, rootState }) {
    // 获取 settings 模块中的默认 menuTagList
    const defaultMenuTagList = rootState.settings.menuTagList
    if (defaultMenuTagList) {
      commit('MERGE_DEFAULT_MENU_TAGLIST', defaultMenuTagList)
    }
  },

  // 从后台 definitions 同步菜单列表（在权限加载后调用）
  syncMenuFromDefinitions({ commit, rootState }) {
    const menuDefinitions = rootState.permission.menuDefinitions
    const disabledPermissions = rootState.permission.disabledPermissions

    if (menuDefinitions && menuDefinitions.length > 0) {
      commit('SYNC_MENU_FROM_DEFINITIONS', { menuDefinitions, disabledPermissions })
    }
  },

  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data)
  },
  updateAlarmReminder({ commit }, data) {
    commit('UPDATE_REMINDER', data)
  },

  // 之前有删除图标时 使用的
  async reportCurTagsDeleteItme({ commit, state }, { data, _this }) {
    // 删除成功后更新数组
    let index = state.reportTags.findIndex((e) => e.custom_id == data.custom_id)
    if (index != -1) {
      // 查询出车辆信息
      let params = {
        customId: data.custom_id,
        state: false,
      }
      await apiDynamicList
        .EditData('ReportCustom/UpdateShortcutState', params, data)
        .then((res) => {
          if (res.state) {
            _this.$message.success(_this.$t('deleteShortcutSuccess'))
            commit('REPORT_CUR_TAGS_DETELE_ITEM', index)
          } else {
            _this.$message.error(res.message)
          }
        })
        .catch((error) => {
          _this.$message.error(_this.$t('alarm_c.saveError'))
        })
    }
  },

  // 获取上传中的数量（统一管理）
  async fetchUploadCount({ commit }) {
    try {
      const res = await apiVideo.GetUploadingCount()
      if (res.state) {
        const count = res.value || 0
        commit('UPDAT_UPLOAD_NUM', count)
        return count
      }
      return 0
    } catch (error) {
      console.error('[tagsView] 获取上传数量失败:', error)
      return 0
    }
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
